import React, { useState } from "react";
import MapBase from "./MapBase";
import useMapProps from "./useMapProps";
import WidgetTable from "./widgets/WidgetTable";
import { MapPropsProvider } from "./MapPropsContext";
import WidgetTableClicked from "./widgets/WidgetTableClicked";
import {
  formatUid,
  getApiUrl,
  getReadableFreq,
} from "../../utils";
import WidgetLegend from "./widgets/WidgetLegend";
import WidgetHelp from "./widgets/WidgetHelp";
import WidgetContainer from "./widgets/WidgetContainer";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import WidgetToolbar from "./widgets/WidgetToolbar";
import AlignCenterText from "./widgets/AlignCenterText";
import { TI_SHOW_LIST_BUTTON } from "../../Constants";
import EllipsisText from "./widgets/EllipsisText";
import { WidgetButton } from "../../styled-components/Button";

const INITIAL_VIEW_STATE = {
  zoom: 8,
};
const ICON_MAPPING = {
  1: ["통제국", "통제국"],
  2: ["우량국", "우량국"],
  3: ["수위국", "수위국"],
  4: ["경보국", "경보국"],
};

const ICON_LEGEND = Object.values(ICON_MAPPING);

const MapPublicRainfall = () => {
  const [isTableVisible, setTableVisible] = useState(false);
  const mapProps = useMapProps({
    INITIAL_VIEW_STATE,
    INITIAL_POINT_LAYER_PROPS: {
      getIconCode: ({ icon }) => {
        try {
          return ICON_MAPPING[icon][0];
        } catch (e) {
          console.error("not found iconCode for", icon);
          return null;
        }
      },
      getIconWidth: (feature, zoom) => {
        let iconWidth = 30;

        if (zoom < 12) {
          iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 18;
          return Math.min(25.2, iconWidth);
        } else if (zoom < 14) {
          iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 15;
          return Math.min(25.2, iconWidth);
        } else {
          iconWidth -= (iconWidth * (15 - Math.max(7, zoom))) / 7;
          return Math.min(30, iconWidth);
        }
      },
    },
  });

  const { clickedPointIconObjects } = mapProps;

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase>
        <WidgetContainer>
          <WidgetDistrictSelect />
        </WidgetContainer>

        <WidgetTableClicked
          fetchUrl={getApiUrl({ type: "type2" })}
          getTitle={(objects) => `${objects.length}개의 우량경보 무선국`}
          objects={clickedPointIconObjects}
          getRow={({ uid, rds_nm, rds_ori_adr }) => (
            <table>
              <tbody>
                <tr>
                  <th>허가번호</th>
                  <td>{formatUid(uid)}</td>
                </tr>
                <tr>
                  <th>우량국명</th>
                  <td>{rds_nm}</td>
                </tr>
                <tr>
                  <th>설치장소</th>
                  <td>{rds_ori_adr}</td>
                </tr>
              </tbody>
            </table>
          )}
        />
        <WidgetHelp />
        <WidgetTable
          visible={isTableVisible}
          setVisible={setTableVisible}
          fetchUrl={getApiUrl({ type: "type1" })}
          getTitle={(layer) => `${layer.length}개의 우량경보 무선국`}
          widgetTabIndex={TI_SHOW_LIST_BUTTON}
          columns={[
            {
              title: "순번",
              dataIndex: "index",
              key: "index",
              width: 75,
              fixed: "left",
              align: "center",
              // sorter: makeTableSorterFn("index"),
            },
            {
              title: "허가번호",
              dataIndex: "uid",
              key: "uid",
              width: 200,
              fixed: "left",
              // render: (uid) => formatUid(uid),
              // sorter: makeTableSorterFn("uid"),
            },
            {
              title: "우량국명",
              dataIndex: "rds_nm",
              key: "rds_nm",
              width: 200,
              // sorter: makeTableSorterFn("rds_nm"),
            },
            {
              title: "우량국 종류",
              dataIndex: "icon_nm",
              key: "icon_nm",
              width: 140,
              // sorter: makeTableSorterFn("icon_nm"),
            },
            {
              title: "설치장소",
              dataIndex: "rds_ori_adr",
              key: "rds_ori_adr",
              render: (rds_ori_adr) => (
                <WidgetButton>
                  <EllipsisText text={rds_ori_adr} />
                </WidgetButton>
              ),
              // sorter: makeTableSorterFn("rds_ori_adr"),
            },
            {
              title: "위도",
              dataIndex: "lat",
              key: "lat",
              width: 140,
              render: (text) => AlignCenterText({ text }),
            },
            {
              title: "경도",
              dataIndex: "lon",
              key: "lon",
              width: 140,
              render: (text) => AlignCenterText({ text }),
            },
            {
              title: "주파수",
              dataIndex: "frq_hz",
              key: "frq_hz",
              width: 140,
              render: getReadableFreq,
              // sorter: makeTableSorterFn("frq_hz"),
            },
          ]}
          horizontalScroll={1400}
        />

        <WidgetLegend iconLegend={ICON_LEGEND} />
      </MapBase>
      <WidgetToolbar />
    </MapPropsProvider>
  );
};

export default MapPublicRainfall;
